/**
 * Generate affiliate search URLs for various retailers
 * Future: Add affiliate tags/tracking parameters
 */

export interface RetailerConfig {
  searchUrlTemplate: string;
  affiliateTag?: string;
}

const RETAILER_CONFIGS: Record<string, RetailerConfig> = {
  amazon: {
    searchUrlTemplate: 'https://www.amazon.com/s?k={query}',
    affiliateTag: 'circlenetwork-20',
  },
  walmart: {
    searchUrlTemplate: 'https://www.walmart.com/search?q={query}',
  },
  target: {
    searchUrlTemplate: 'https://www.target.com/s?searchTerm={query}',
  },
  'home-depot': {
    searchUrlTemplate: 'https://www.homedepot.com/s/{query}',
  },
  lowes: {
    searchUrlTemplate: 'https://www.lowes.com/search?searchTerm={query}',
  },
};

/**
 * Generate a retailer-specific search URL
 */
export function generateAffiliateUrl(
  retailerSlug: string,
  searchQuery: string
): string {
  const config = RETAILER_CONFIGS[retailerSlug.toLowerCase()];
  
  if (!config) {
    console.warn(`No retailer config found for: ${retailerSlug}`);
    return `https://www.google.com/search?q=${encodeURIComponent(searchQuery)}`;
  }

  let url = config.searchUrlTemplate.replace(
    '{query}',
    encodeURIComponent(searchQuery)
  );

  // Add affiliate tag if configured
  if (config.affiliateTag) {
    url += `&tag=${config.affiliateTag}`;
  }

  return url;
}

/**
 * Generate "Buy All" links for all items in a bundle
 */
export function generateBuyAllUrls(
  retailerSlug: string,
  items: Array<{ search_query: string; name: string }>
): Array<{ name: string; url: string }> {
  return items.map(item => ({
    name: item.name,
    url: generateAffiliateUrl(retailerSlug, item.search_query),
  }));
}
